<template>
    <v-dialog v-model="show" max-width="400">
        <v-card v-if="show">
            <v-card-title class="subtitle-1 font-weight-bold">캐시 충전</v-card-title>
            <v-card-text>
                <v-text-field v-model="cash.price" label="금액" type="number" placeholder=" " :hint="(+cash.price || 0).format()" persistent-hint></v-text-field>
                <v-text-field v-model="cash.remark" label="비고" placeholder=" " hide-details class="mt-3"></v-text-field>
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn text color="grey" @click="cancel">취소</v-btn>
                <v-btn text color="primary" @click="save" :disabled="disabled">확인</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";

export default {
    data(){
        return {
            show: false,
            
            cp: null,
            cash: {
                price: 0,
                remark: null
            },

            disabled: false,
        }
    },
    methods: {
        clear(){
            this.cash = {
                price: 0,
                remark: null
            };
        },
        open(){
            this.clear();
            this.show = true;
            this.disabled = false;
        },
        close(){
            this.cp = null;
            this.show = false;
        },
        cancel(){
            this.close();
        },
        async save(){
            try{
                if(confirm( `[(CP명 - ${this.cp.name})에 (${Number(+this.cash.price).format()})캐시를 충전하시겠습니까?]`)) {
                    this.disabled = true;
                    await api.console.cps.charge({
                    ...this.cp,
                    cash: this.cash
                    });

                    this.close();
                    this.$emit("save");
                }
            }
            catch(error){
                console.error(error);
            }
        }

    }
}
</script>